import { render, staticRenderFns } from "./ImportantAccountsStep.vue?vue&type=template&id=9bccd910"
import script from "./ImportantAccountsStep.vue?vue&type=script&lang=js"
export * from "./ImportantAccountsStep.vue?vue&type=script&lang=js"
import style0 from "./ImportantAccountsStep.vue?vue&type=style&index=0&id=9bccd910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports